import { render, staticRenderFns } from "./AddNewInventory.vue?vue&type=template&id=68602036"
import script from "./AddNewInventory.vue?vue&type=script&lang=js"
export * from "./AddNewInventory.vue?vue&type=script&lang=js"
import style0 from "./AddNewInventory.vue?vue&type=style&index=0&id=68602036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports